import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};
const noCacheMeta = {
    auth: false
};

export default {
    path: '/bpm',
    name: 'bpmAdmin',
    redirect: {
        name: 'bpmAdmin'
    },
    meta,
    component: BasicLayout,
    children: [
    	{
            path:'/bpm/admin/definitionList',
            name:'definitionList',
            meta: {
                ...meta,
                title:'$t:menu.simpleprocessmanagement',
                desc:'简易式流程管理'
            },
            component: () => import('@/pages//bpm/admin/definitionList')
        },
        {
            path:'/bpm/admin/taskList',
            name:'taskList',
            meta: {
                ...meta,
                title:'$t:menu.taskList',
                desc:'任务列表'
            },
            component: () => import('@/pages/bpm/admin/taskList')
        },
       {
            path: '/bpm/admin/instanceTaskManager/:id',
            name: 'instanceTaskManager',
            meta: {
                auth: false,
                cache: false,
                title:'$t:menu.instanceTaskManager',
                desc:'任务调整',
            },
            component: () => import('@/pages/bpm/admin/instanceTaskManager.vue')
        },
        {
            path:'/bpm/admin/instanceList',
            name:'instanceList',
            meta: {
                ...meta,
                title:'$t:menu.instanceList',
                desc:'流程实例'
            },
            component:()=> import('@/pages/bpm/admin/instanceList')
        },
        {
            path:'/bpm/admin/instanceList_org',
            name:'instanceList_org',
            meta: {
                ...meta,
                title:'$t:menu.instanceList_org',
                desc:'流程实例-部门'
            },
            component:()=> import('@/pages/bpm/admin/instanceList_org')
        },
        {
            path: '/statics/applyAvgTimes',
            name: 'applyAvgTimes',
            meta: {
                ...noCacheMeta,
                title:'$t:menu.applyAvgTimes',
                desc: '流程办结耗时统计',
            },
            component: () => import('@/pages/statics/applyAvgTimes')
        },
        {
            path: '/statics/approveCount',
            name: 'approveCount',
            meta: {
                ...noCacheMeta,
                title:'$t:menu.approveCount',
                desc: '任务处理量统计',
            },
            component: () => import('@/pages/statics/approveCount')
        },
        {
            path: '/statics/applyCount',
            name: 'applyCount',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.applyCount',
                desc: '流程申请量统计',
            },
            component: () => import('@/pages/statics/applyCount')
        },
        {
            path: '/statics/approveAvgTimes',
            name: 'approveAvgTimes',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.approveAvgTimes',
                desc: '任务处理平均耗时',
            },
            component: () => import('@/pages/statics/approveAvgTimes')
        },
        {
            path: '/statics/finishedRate',
            name: 'finishedRate',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.finishedRate',
                desc: '流程办结率统计',
            },
            component: () => import('@/pages/statics/finishedRate')
        }
    ],

};
